import React from "react";
import { useCheckoutContext } from "../../context/useCheckoutContext";
import ButtonHeader from "./ButtonHeader/ButtonHeader";
import SimpleHeader from "./SimpleHeader/SimpleHeader";
import ConfrontaHeader from "./ConfrontaHeader/ConfrontaHeader";
export var CheckoutHeader = function () {
    var _a = useCheckoutContext().checkoutSection.header, isSimpleHeader = _a.isSimpleHeader, isConfronta = _a.isConfronta;
    return isSimpleHeader ? (React.createElement(SimpleHeader, null)) : isConfronta ? (React.createElement(ConfrontaHeader, null)) : (React.createElement(ButtonHeader, null));
};
export default CheckoutHeader;
